import startCase from "lodash/fp/startCase";
import forEach from "lodash/fp/forEach";

class Controller {
  constructor(Events, City) {
    "ngInject";

    this.Events = Events;
    this.City = City;

    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.updateCheckingConfiguration = this.updateCheckingConfiguration.bind(
      this
    );
  }

  $onInit() {
    this.City.getRideCategory({ city: this.cityId }).$promise.then(
      (response) => {
        const formatCategory = (
          acc,
          { _source: { _id, ride_type: rideType, service_type: serviceType } }
        ) => {
          acc[_id] = {
            title: startCase(`${rideType} ${serviceType}`),
          };

          return acc;
        };

        this.rideCategoryList = response.hits.reduce(formatCategory, {});

        forEach(({ category }) => {
          this.applyTaken(category);
        })(this.checkingConfig);
      }
    );
  }

  addConfig() {
    this.checkingConfig.push({
      category: null,
      checkin_delay: 0,
      checkout_delay: 0,
      checkin_flag: false,
      miss_delta_time: 0,
    });
  }

  removeConfig(index, form) {
    const { category } = this.checkingConfig[index];
    if (category) this.rideCategoryList[category].taken = false;
    this.checkingConfig.splice(index, 1);
    if (!form.dirty) form.$setDirty();
  }

  applyTaken(newVal, oldVal) {
    if (oldVal) this.rideCategoryList[oldVal].taken = false;
    this.rideCategoryList[newVal].taken = true;
  }

  updateCheckingConfiguration() {
    const payload = {
      checking_config: this.checkingConfig,
    };
    this.City.patchAction(
      this.cityId,
      "update_checking",
      payload
    ).$promise.then(
      () => {
        this.checkingConfig.isDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "City Checking Config are updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/captainInRideControls/captainInRideControls.controller.js